import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/zopping-themes/zopping-themes/themes/common/LayoutSkelatonLoader/index.jsx");
